import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { ServiceImpl } from './service-impl';

export function makeService() {
  return new ServiceImpl(makeLogService(), makeAuthService());
}
